exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".backButton-1d331{color:#fff}", ""]);

// Exports
exports.locals = {
	"backButton": "backButton-1d331"
};